export default "__VITE_ASSET__CNQRfL5E__"